var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-card"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"box"},[(!_vm.franchisesOpen)?_c('AutoCheckCertificateOptions',{attrs:{"options-data":_vm.data},on:{"next":_vm.toggleFranchises}}):_c('AutoCheckCertificateFranchises',{attrs:{"franchise-data":_vm.data},on:{"back":_vm.toggleFranchises}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }